import { request } from "./request.js";
import { PROJECT_ERP } from "@/constant";

/**
 * 获取oss上传token
 * @returns
 */
export const getOssUploadData = () => {
  return request({
    url: "/open/Merchants/getOssUploadData",
    method: "post",
    project: PROJECT_ERP,
  });
};

/**
 * 获取oss上传token
 * @returns
 */
export const getObsUploadData = () => {
  return request({
    url: "/open/Merchants/getObsUploadData",
    method: "post",
    project: PROJECT_ERP,
  });
};

/**
 * 获取下拉选项
 * @returns
 */
export const getSelectOps = () => {
  return request({
    url: "/open/Merchants/getSelectOps",
    method: "post",
    project: PROJECT_ERP,
  });
};

/**
 * 获取图形验证码
 * @returns
 */
export const getVerifyCode = () => {
  return request({
    url: "/open/Merchants/getVerifyCode",
    method: "post",
    project: PROJECT_ERP,
  });
};

/**
 * 填写招商入驻信息
 * @returns
 */
export const settleIn = (data) => {
  return request({
    url: "/open/Merchants/settleIn",
    method: "post",
    data,
    project: PROJECT_ERP,
  });
};

/**
 * 判断是否填写过
 * @param {*} data
 * @returns
 */
export const hasInput = (data) => {
  return request({
    url: "/open/Merchants/hasInput",
    method: "post",
    data,
    project: PROJECT_ERP,
  });
};
